import { Schema } from '../../../utils/form';
import { FormattedMessage } from 'react-intl';

export default Schema.object({
  area: Schema.string().label(''),
  areas: Schema.string().label(''),
  areasSubordinadas: Schema.string().label(''),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  responsavel: Schema.string().label(''),
  responsaveis: Schema.string().label(''),
  idIntegracao: Schema.string().label(<FormattedMessage id="codigo" />),
  processos: Schema.array().label(''),
  incluirSubprocessos: Schema.boolean().label(''),
  camposCustomizados: Schema.array(),
  statusRisco: Schema.array(),
  filtroMatrizRisco: Schema.string().label(''),
});
